import { render, staticRenderFns } from "./Wonder.vue?vue&type=template&id=0e290400&scoped=true"
import script from "./Wonder.vue?vue&type=script&lang=js"
export * from "./Wonder.vue?vue&type=script&lang=js"
import style0 from "./Wonder.vue?vue&type=style&index=0&id=0e290400&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e290400",
  null
  
)

export default component.exports